import React from "react";
import { FaSquareFacebook, FaSquareInstagram } from "react-icons/fa6";
import { FaTiktok } from "react-icons/fa6";
import "../style/footer.css";

// Components
import Filmstrip from "../components/Filmstrip";
export default function Footer() {
  return (
    <div className="Footer">
      <div className="footer_Top">
        <div className="social_Media">
          <a
            href="https://www.facebook.com/vintagecollectiveph"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaSquareFacebook />
          </a>

          {/* <a
            href="http://www.instagram.com/the_vintage_collective"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaSquareInstagram />
          </a> */}

          <a
            href="https://www.tiktok.com/@thevintagecollectiveph"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTiktok />
          </a>
        </div>
        <div>
          <a
            href="https://thevintagecollective.shop/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <span>Privacy Policy</span>
          </a>{" "}
          |{" "}
          <a
            href="https://thevintagecollective.shop/terms-and-conditions"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <span>Terms and Services</span>
          </a>{" "}
          |{" "}
          <a
            href="  https://thevintagecollective.shop/contact"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <span>Contact Us</span>
          </a>{" "}
        </div>
      </div>

      <Filmstrip />
    </div>
  );
}
